import { useState } from "react";
import Block from './block1';

// Déplacer PrescriptionForm en dehors du composant principal
const PrescriptionForm = ({ medications, handleMedicationChange, addNewMedication }) => (
  <div className="row prescription">
    <div className="w-full max-w-2xl p-4 bg-white rounded-lg div-relative">
      <div className="flex flex-col gap-4">
        {medications.map((medication) => (
          <div key={medication.id} className="medication-entry">
            <div className="w-full">
              <div className="flex items-center gap-2">
                <Block
                  initialLabel="Nom du médicament"
                  initialContent={medication.name}
                  inputType="text"
                  onContentChange={(value) => handleMedicationChange(medication.id, "name", value)}
                  value={medication.name}
                />
              </div>
            </div>

            <div className="row mleft mt-4" style={{ borderLeft: '5px solid #FF98004F' }}>
              <div className="col items-center">
                <Block
                  initialLabel="Nbr de boites"
                  initialContent={medication.boxes}
                  inputType="number"
                  onContentChange={(value) => handleMedicationChange(medication.id, "boxes", value)}
                  value={medication.boxes}
                />
              </div>

              <div className="col items-center">
                <Block
                  initialLabel="Prises"
                  inputType="text"
                  initialContent={medication.dosage}
                  onContentChange={(value) => handleMedicationChange(medication.id, "dosage", value)}
                  value={medication.dosage}
                />
              </div>

              <div className="col items-center">
                <Block
                  initialLabel="Durée(jours)"
                  initialContent={medication.duration}
                  inputType="text"
                  onContentChange={(value) => handleMedicationChange(medication.id, "duration", value)}
                  value={medication.duration}
                />
              </div>
            </div>

            {medication.id !== 1 && <div className="border-b border-gray-200 my-4" />}
          </div>
        ))}

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-prim"
            style={{ color: '#0056B3' }}
            onClick={addNewMedication}
          >
            <i className="bi bi-plus-circle-fill me-2"></i>
            <span style={{ textDecoration: 'underline' }}>Add Medication</span>
          </button>
        </div>
      </div>
    </div>
  </div>
);

const EditableBlockList = ({ onPrescriptionsChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [medications, setMedications] = useState([
    {
      id: 1,
      name: "Nom du medicament",
      boxes: "1",
      dosage: "Dosage",
      duration: "Duree"
    }
  ]);

  const addNewMedication = () => {
    const newId = medications.length > 0 ? Math.max(...medications.map(m => m.id)) + 1 : 1;
    const newMedication = {
      id: newId,
      name: "",
      boxes: "",
      dosage: "",
      duration: ""
    };
    const updatedMedications = [...medications, newMedication];
    setMedications(updatedMedications);
    onPrescriptionsChange?.(updatedMedications);
  };

  const handleMedicationChange = (id, field, value) => {
    const updatedMedications = medications.map(medication => 
      medication.id === id ? { ...medication, [field]: value } : medication
    );
    setMedications(updatedMedications);
    onPrescriptionsChange?.(updatedMedications);
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold ms-5"
          onClick={() => setIsOpen(!isOpen)}
        >
          Medications
          <i
            className="bi bi-caret-down-fill"
            style={{ color: '#FF9800' }}
          ></i>
        </p>
      </div>

      {isOpen && (
        <PrescriptionForm
          medications={medications}
          handleMedicationChange={handleMedicationChange}
          addNewMedication={addNewMedication}
        />
      )}
    </div>
  );
};

export default EditableBlockList;
